"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fineText = exports.smallText = exports.defaultText = exports.sectionHeadersText = exports.subheadersText = exports.headersText = void 0;
const styled_components_1 = require("styled-components");
const theme_1 = __importDefault(require("./theme"));
exports.headersText = styled_components_1.css `
  font-size: ${theme_1.default.font.size.xxl.fontSize};
  line-height: ${theme_1.default.font.size.xxl.lineHeight};
`;
exports.subheadersText = styled_components_1.css `
  font-size: ${theme_1.default.font.size.xl.fontSize};
  line-height: ${theme_1.default.font.size.xl.lineHeight};
`;
exports.sectionHeadersText = styled_components_1.css `
  font-size: ${theme_1.default.font.size.l.fontSize};
  line-height: ${theme_1.default.font.size.l.lineHeight};
`;
exports.defaultText = styled_components_1.css `
  font-size: ${theme_1.default.font.size.m.fontSize};
  line-height: ${theme_1.default.font.size.m.lineHeight};
`;
exports.smallText = styled_components_1.css `
  font-size: ${theme_1.default.font.size.s.fontSize};
  line-height: ${theme_1.default.font.size.s.lineHeight};
`;
exports.fineText = styled_components_1.css `
  font-size: ${theme_1.default.font.size.xs.fontSize};
  line-height: ${theme_1.default.font.size.xs.lineHeight};
`;
